// extracted by mini-css-extract-plugin
export default {"default":"_type_default__+ucay","dense":"_type_dense__U0kWB","card":"_type_card__qxv1m","circle":"_type_circle__MyrIf","action":"_type_action__EMkfl","icon":"_type_icon__byLti"};